import React, { Component } from "react";
import { RVRequestsProps } from "./RVRequestsListView";
import GridDataView from "@my-dld/components/DataView/GridDataView";
import { AuditedRVRequest } from "../../../api/entities";
import Strings from "@my-dld/assets/strings";
import { getRVRequestStatusClass } from "../../../RVUtils";
import { getRVReqArea, getRVReqDate, getRVReqPropertyType, getRVReqStatus } from "./RVRequests";

class RVRequestsGridView extends Component<RVRequestsProps> {
	render() {
		const { requests, onDetails } = this.props;
		return <GridDataView
			items={ requests }
			renderGridItem={ ( item: AuditedRVRequest ) => {
				return <RenderGridItem
					key={ `rv_req_${ item.RequestNumber }` }
					request={ item }
					onDetails={ onDetails }/>;
			} }/>;
	}
}

function RenderGridItem( props: { request: AuditedRVRequest, onDetails: ( request: AuditedRVRequest ) => void } ) {
	const { request, onDetails } = props;
	const statusClass = getRVRequestStatusClass( request.RequestStatusId, request.AuditStatusId );
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getRVReqPropertyType( request ) }</span>
							<span>{ Strings.property_type }</span>
						</div>
						<div className={ `property-status ${ statusClass }` }>
							{ getRVReqStatus( request ) }
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-12">
							<span>{ getRVReqArea( request ) }</span>
							<span>{ Strings.area }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-8">
							<span>{ request.RequestNumber }</span>
							<span>{ Strings.request_number }</span>
						</div>
						<div className="col-4">
							<span>{ getRVReqDate( request ) }</span>
							<span>{ Strings.request_date }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-action">
						<div className="col-md-12">
							<button
								className="btn-link" onClick={ () => {
								onDetails( request );
							} }>{ Strings.view_details }</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default RVRequestsGridView;
